module.exports = {"330702001":"城东街道","330702002":"城中街道","330702003":"城西街道","330702004":"城北街道","330702005":"江南街道","330702006":"三江街道","330702007":"西关街道","330702008":"秋滨街道","330702009":"新狮街道","330702100":"罗店镇","330702101":"雅畈镇","330702102":"安地镇","330702103":"白龙桥镇","330702104":"琅琊镇","330702105":"蒋堂镇","330702106":"汤溪镇","330702107":"罗埠镇","330702108":"洋埠镇","330702201":"乾西乡","330702202":"竹马乡","330702203":"长山乡","330702204":"箬阳乡","330702205":"沙畈乡","330702206":"塔石乡","330702208":"莘畈乡","330702209":"苏孟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330702.json
// module id = 1100
// module chunks = 0